import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  automateFor: {
    description: 'Label preceding the automation tool filter pills',
    defaultMessage: 'Automate for:',
    id: 'R2jBE8',
  },
  filterEverything: {
    description: 'Filter pill label to show all automation tools',
    defaultMessage: 'Everything',
    id: 'NjBlt1',
  },
  filterPreparingOrders: {
    description: 'Filter pill label for order preparation tools',
    defaultMessage: 'Preparing Orders',
    id: 'AyURVY',
  },
  filterDecidingHowToShip: {
    description: 'Filter pill label for shipping decision tools',
    defaultMessage: 'Deciding How to Ship',
    id: 'lrM14W',
  },
  filterFulfillingAtScale: {
    description: 'Filter pill label for high-volume fulfillment tools',
    defaultMessage: 'Fulfilling at Scale',
    id: 'rqrvH6',
  },
  inactive: {
    description: 'Status pill label shown on automation tool cards that have not been configured',
    defaultMessage: 'Inactive',
    id: 'BFanvC',
  },
  setUp: {
    description: 'Button label for an automation tool that has not been configured yet',
    defaultMessage: 'Set Up',
    id: 'F1W79q',
  },
  manage: {
    description: 'Button label for an automation tool that has already been configured',
    defaultMessage: 'Manage',
    id: 'LPFrhq',
  },
  orderRoutingTitle: {
    description: 'Title for the Order Routing automation tool card',
    defaultMessage: 'Order Routing',
    id: 'TzdJHp',
  },
  orderRoutingDescription: {
    description: 'Description for the Order Routing automation tool card',
    defaultMessage: "Automate which warehouses stock the order items and which warehouses are closest to the recipient's address",
    id: 'CjPR9l',
  },
  productPresetGroupsTitle: {
    description: 'Title for the Product Preset Groups automation tool card',
    defaultMessage: 'Product Preset Groups',
    id: 'CAWI/S',
  },
  productPresetGroupsDescription: {
    description: 'Description for the Product Preset Groups automation tool card',
    defaultMessage: 'Set weight, dimensions, domestic and international shipping services, and customs information for multiple products.',
    id: 'CeoQV9',
  },
  serviceMappingsTitle: {
    description: 'Title for the Service Mappings automation tool card',
    defaultMessage: 'Service Mappings',
    id: 'Nxav1Z',
  },
  serviceMappingsDescription: {
    description: 'Description for the Service Mappings automation tool card',
    defaultMessage: 'Set the shipping service and package type based on preference or what your customer chose during checkout.',
    id: 'CzBgZx',
  },
  rateShopperTitle: {
    description: 'Title for the Rate Shopper automation tool card',
    defaultMessage: 'Rate Shopper',
    id: 'nVHX4k',
  },
  rateShopperDescription: {
    description: 'Description for the Rate Shopper automation tool card',
    defaultMessage: "Configure which services you'd like to compare, as well as define any delivery time or service requirements",
    id: 'hn8qyA',
  },
  automationRulesTitle: {
    description: 'Title for the Automation Rules automation tool card',
    defaultMessage: 'Automation Rules',
    id: 'O0jLm0',
  },
  automationRulesDescription: {
    description: 'Description for the Automation Rules automation tool card',
    defaultMessage:
      'Use logic to identify triggers that can fire actions. Automation rules are the most customizable of all automation features.',
    id: 'zL4JaH',
  },
  smartFillTitle: {
    description: 'Title for the Smart Fill automation tool card',
    defaultMessage: 'Smart Fill',
    id: 'rXVOUb',
  },
  smartFillDescription: {
    description: 'Description for the Smart Fill automation tool card',
    defaultMessage: 'Automatically configure shipment weight and dimensions based on our previous configurations for similar orders.',
    id: 'dh7Vt+',
  },
});
